import script from "./viewGroupDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./viewGroupDetails.vue?vue&type=script&setup=true&lang=js"

import "./viewGroupDetails.vue?vue&type=style&index=0&id=6643e8b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6643e8b8"]])

export default __exports__